// Copyright (c) 2020 Verimatrix, Inc.  All Rights Reserved.

import {LOOKER_GET_DASHBOARD, LOOKER_INLINE_QUERY, LOOKER_CLEAR_DASHBOARD, LOOKER_CLEAR_QUERIES} from '../actions/looker'

const initialState = {
  dashboard: null,
  queryResults: null
}

export default function (state = initialState, action) {
  switch (action.type) {
    case LOOKER_CLEAR_DASHBOARD:
      return {initialState}
    case LOOKER_CLEAR_QUERIES:
      return {...state, queryResults: null}
    case LOOKER_GET_DASHBOARD:
      return {...state, dashboard: action.payload, last_refresh_date: new Date()}
    case LOOKER_INLINE_QUERY: {
      let queryResults = {...state.queryResults}
      queryResults[action.payload.dashboard_element_id] = action.payload
      return {...state, queryResults: queryResults}
    }
    default:
      return state
  }
}

